import { get } from 'lodash';
import { call, put, takeLatest } from 'redux-saga/effects';
import { Response } from 'store/global/types';
import { searchPolicyFail, searchPolicySuccess } from './actions';
import * as api from './apis';
import { SEARCH_POLICY_ACTIONS } from './constants';

export function* search({ payload }: any) {
  try {
    const response: Response = yield call(api.searchPolicy, payload);
    if (get(response, 'data.success', false)) {
      yield put(searchPolicySuccess(get(response, 'data.data', [])));
    } else {
      yield put(searchPolicyFail(response.data));
    }
  } catch (error) {
    yield put(searchPolicyFail(error));
  }
}

export function* watchSearch() {
  yield takeLatest(SEARCH_POLICY_ACTIONS.START, search);
}

export default [watchSearch];
